__webpack_require__.p = "/reports-dashboard-templates-components-id-collision/referrals-hub/";